import inputable from '../Form/inputable';
import Container from './Container';
var Slider = inputable(Container);
Slider.displayName = 'ShineoutSlider';
export default Slider;